import {useEffect} from 'react';

export function useOnClickOutside<T extends HTMLElement = HTMLElement>(
  ref: React.RefObject<T>,
  handler: () => void,
): void {
  useEffect(() => {
    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  });
  const handleClick = (e: MouseEvent | TouchEvent) => {
    if (ref?.current && !ref?.current.contains(e.target as Node)) {
      handler();
    }
  };
}
export default useOnClickOutside;
